import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { BrowserModule, Title } from '@angular/platform-browser';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SignaturePadModule } from 'angular2-signaturepad';
import { TextInputAutocompleteModule } from 'angular-text-input-autocomplete';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


import { AppComponent } from './components/app/app.component';
import { NavMenuComponent } from './components/navmenu/navmenu.component';
import { HomeComponent } from './components/home/home.component';
import { CheckListComponent } from "./components/checklist/checklist.component";
import { YourInfoComponent } from "./components/yourinfo/yourinfo.component";
import { MapComponent } from "./components/map/map.component";
import { PrequalificationComponent } from "./components/prequalification/prequalification.component";
import { PrequalificationDriverComponent } from "./components/prequalificationdriver/prequalificationdrver.component";
import { OwnerComponent } from "./components/owner/owner.component";
import { OtherdriverComponent } from "./components/otherdriver/otherdriver.component";
import { InjuryComponent } from "./components/injury/injury.component";
import { WitnessComponent } from "./components/witness/witness.component";
import { InvolvedComponent } from "./components/involved/involved.component";
import { InvolvedPedComponent } from "./components/involvedped/involvedped.component";
import { VehicleDriverLocationComponent } from "./components/vehicledriverlocation/vehicledriverlocation.component";
import { EnvironmentComponent } from "./components/environment/environment.component";
import { TrafficEventComponent } from "./components/trafficevent/trafficevent.component";
import { StatementComponent } from "./components/statement/statement.component";
import { EmailComponent } from "./components/email/email.component";
import { CouncellorReviewComponent } from "./components/counsellorreview/councellorreview.component";
import { FinalPageComponent } from "./components/finalpage/finalpage.component";


// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}
@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        CheckListComponent,
        YourInfoComponent,
        MapComponent,
        PrequalificationComponent,
        PrequalificationDriverComponent,
        OwnerComponent,
        OtherdriverComponent,
        InjuryComponent,
        WitnessComponent,
        InvolvedComponent,
        InvolvedPedComponent,
        VehicleDriverLocationComponent,
        EnvironmentComponent,
        TrafficEventComponent,
        StatementComponent,
        EmailComponent,
        CouncellorReviewComponent,
        FinalPageComponent
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forRoot([
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent },
            { path: 'checklist', component: CheckListComponent, data: { title: "Checklist" } },
            { path: 'yourinfo', component: YourInfoComponent, data: { title: "Your Information" } },
            { path: 'map', component: MapComponent, data: { title: "Map" } },
            { path: 'prequalification', component: PrequalificationComponent, data: { title: "Pre-qualification" } },
            { path: 'prequalificationdriver', component: PrequalificationDriverComponent, data: { title: "Pre-qualification" } },
            { path: 'owner', component: OwnerComponent, data: { title: "owner" } },
            { path: 'otherdriver', component: OtherdriverComponent, data: { title: "Other Driver" } },
            { path: 'injury', component: InjuryComponent, data: { title: "Injury" } },
            { path: 'witness', component: WitnessComponent, data: { title: "Witness" } },
            { path: 'involved', component: InvolvedComponent, data: { title: "Involved" } },
            { path: 'involvedped', component: InvolvedPedComponent, data: { title: "Involvedped" } },
            { path: 'vehicledriverlocation', component: VehicleDriverLocationComponent, data: { title: "Location" } },
            { path: 'environment', component: EnvironmentComponent, data: { title: "Environment" } },
            { path: 'trafficevent', component: TrafficEventComponent, data: { title: "Traffic Event" } },
            { path: 'statement', component: StatementComponent, data: { title: "Statement" } },
            { path: 'email', component: EmailComponent, data: { title: "Email" } },
            { path: 'counsellorreview', component: CouncellorReviewComponent, data: { title: "Counsellor Review" } },
            { path: 'finalpage', component: FinalPageComponent, data: {title:"Final Page"} },
            { path: '**', redirectTo: 'home' }
        ])        ,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        [SignaturePadModule],
        TextInputAutocompleteModule,
        Ng4LoadingSpinnerModule.forRoot(), NgbModule
    ],
    providers: [
        Title
    ],
    bootstrap: [AppComponent]
})
export class AppModuleShared {
}


